import React from "react";
import PropTypes from "prop-types";

import { useResetPasswordForm } from "scenes/Authentication/hooks";

import { Layout, VerifyCodeInfoMessage } from "..";
import { ResetPasswordForm } from "./components";

export function ResetPasswordPage({ email, onDone }) {
  const { reset, loading, error, resendCode } = useResetPasswordForm(
    { email },
    onDone
  );

  if (!email) return <div>Email is required to reset password.</div>;

  return (
    <div data-test="reset-password-form">
      <Layout
        errorMessage={error}
        infoMessage={<VerifyCodeInfoMessage email={email} />}
      >
        <ResetPasswordForm
          onSubmit={reset}
          onResendCode={resendCode}
          loading={loading}
        />
      </Layout>
    </div>
  );
}

ResetPasswordPage.propTypes = {
  email: PropTypes.string,
  onDone: PropTypes.func.isRequired,
};

ResetPasswordPage.defaultProps = {
  email: "",
};

export default ResetPasswordPage;
